import React from "react";
import { NavLink } from 'react-router-dom';
import { NavItem } from 'reactstrap';
import {FaFilePdf} from 'react-icons/fa'
import Menu from 'react-burger-menu/lib/menus/slide'

import "./NnMenus.scss";

const NnPdfMenu = ({displayLetters, notation, isOpen, onChange, onClose, onKeyDown, song}) => (
  <Menu id="pdf-menu"
    burgerButtonClassName="no-menu-button"
    crossButtonClassName="menu-close-button"
    menuClassName={'menu'}
    itemListClassName={"menu-item-list"}
    itemClassName={"menu-item"}
    customOnKeyDown={onKeyDown}
    isOpen={isOpen}
    onStateChange={onChange}
    right
    width={'60%'}
  >
    <ul>
      {['Beginner', 'Intermediate', 'Advanced'].map(level =>
        <NavItem key={level} onClick={onClose}>
          <NavLink
            className="nav-link"
            to={song.pdfUrlFromeSongId(displayLetters, level)}
            target="_blank"
            onClick={onKeyDown}>
            <FaFilePdf/>{level}, {notation} Notation
          </NavLink>
        </NavItem>
      )}
    </ul>
  </Menu>
)
export default NnPdfMenu
